import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../../axiosAuth";
import { SCHOOL_INSTALLMENT_INVOICE_BY_INSTALLMENT_ID } from "../../../apiRoutes";

export interface InvoiceDetailsData {
  expectedInvoiceGenerationDate: string;
  expectedInvoiceSubmissionDate: string;
  expectedInvoiceClearanceDate: string;
  invoiceGenerationDate: string;
  invoiceCode: any;
  invoiceFile: string;
  invoiceOwner: string;
  bankAccountDetail: string;
  uploadedInvoice: string;
  invoiceSubmissionDate: string;
  invoiceRemark: string;
  invoiceId: string;
  invoiceOwnerDetail: {
    _id: string;
    name: string;
    profile_id: string;
  };
  _id: string;
}

export interface InvoiceDetailsResponse {
  data: InvoiceDetailsData;
}

const fetchInvoiceDetailsByInstallmentId = async (installmentId: string) => {
  const response = await axiosAuth.get<InvoiceDetailsResponse>(
    `${SCHOOL_INSTALLMENT_INVOICE_BY_INSTALLMENT_ID}${installmentId}`
  );
  return response.data;
};

export const useGetInvoiceDetailsByInstallmentIdQuery = (
  installmentId: string,
  queryParams?: Omit<
    UseQueryOptions<
      InvoiceDetailsResponse,
      Error,
      InvoiceDetailsResponse,
      ["invoice-detail", string]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    InvoiceDetailsResponse,
    Error,
    InvoiceDetailsResponse,
    ["invoice-detail", string]
  >({
    queryKey: ["invoice-detail", installmentId],
    queryFn: () => fetchInvoiceDetailsByInstallmentId(installmentId),
    enabled: !!installmentId,
    ...(queryParams || {}),
  });
